<template>
  <div class="footer">
    <div class="left">
      <div class="small_logo">
        <img
          v-if="this.$store.state.currentLang === 'zh'"
          :src="this.$path + '/assets/images/logo-zh.png'"
          :alt="$t('langs.aolei')"
        />
        <img
          v-if="this.$store.state.currentLang === 'en'"
          :src="this.$path + '/assets/images/logo-en.png'"
          :alt="$t('langs.aolei')"
        />
      </div>
      <div class="small_imgs">
        <img
          :src="this.$path + '/assets/images/qq.png'"
          :alt="$t('langs.qq')"
          style="display: none;"
          @mouseenter="mouseenter('qq')"
          @mouseleave="mouseleave"
        />
        <img
          :src="this.$path + '/assets/images/wx.png'"
          :alt="$t('langs.weixin')"
          @mouseenter="mouseenter('wx')"
          @mouseleave="mouseleave"
        />
        <img
          :src="this.$path + '/assets/images/mobile.png'"
          :alt="$t('langs.mobile')"
          @mouseenter="mouseenter('tel')"
          @mouseleave="mouseleave"
        />
      </div>
      <ul class="info" ref="info" @mouseleave="mouseleave">
        <li :style="qqstyle" @mouseenter="mouseenter('qq')">
          <p>
            <a href="http://wpa.qq.com/msgrd?v=3&amp;uin=2099920797&amp;site=qq&amp;menu=yes"   target="_blank" >{{$t('langs.online')}}</a>
          </p>
        </li>
        <li :style="telstyle" @mouseenter="mouseenter('tel')">
          <p>
            <span class="tel_consult">{{ $t("langs.hotline") }}  <span style="display: block">+86 18126287990</span></span> 
          </p>
        </li>
        <li :style="wxstyle" @mouseenter="mouseenter('wx')">
          <div class="img">
             <span style="display: block;padding-top: 6px;font-size: 13px;margin-left: 7px;">{{
              $t("langs.weixinhot")
            }}</span>
             <img style="height: 74px;width: 74px;padding: 2px 10px 10px 10px;" :src="this.$path + '/assets/images/aray_weixin.jpg'" />
          </div>
        </li>
      </ul>
    </div>
    <div class="center">
      <div class="footer_title">
        <span class="text_left title_footer">{{ $t("langs.product") }}</span>
        <span class="text_center title_footer">{{ $t("langs.about") }}</span>
        <span class="text_right title_footer">{{ $t("langs.contact") }}</span>
      </div>
      <div class="footer_text">
        <span class="text_left">
          <router-link to="/centerpower">
            {{
            $t("langs.energystoragebattery")
            }}
          </router-link>
        </span>
        <span class="text_center">
          <router-link to="/about">
            {{
            $t("langs.enterprise")
            }}
          </router-link>
        </span>
        <span class="text_right">{{ $t("langs.consultation") }} +86 18126287990</span>
      </div>
      <div class="footer_text">
        <span class="text_left">
          <router-link to="/centerbms">
            {{
            $t("langs.bmsbattery")
            }}
          </router-link>
        </span>
        <span class="text_center">
          <router-link to="/about">
            {{
            $t("langs.innovate")
            }}
          </router-link>
        </span>
        <span class="text_right">{{ $t("langs.busnissmailbox") }}：commerce@araypower.cn</span>
      </div>
      <div class="footer_text">
        <span class="text_left">
          <router-link to="/centercloud">
            {{
            $t("langs.twothreewheeledvehicle")
            }}
          </router-link>
        </span>
        <span class="text_center">
          <router-link to="/about">{{ $t("langs.global") }}</router-link>
        </span>
        <span class="text_right">{{ $t("langs.servicemailbox") }}：service@araypower.cn</span>
      </div>
      <div class="footer_text">
        <span class="text_left">
          <router-link to="/centerwifi">
            {{
            $t("langs.cloudmanage")
            }}
          </router-link>
        </span>
        <span class="text_center">
          <router-link to="/about">{{ $t("langs.onlineenquiry") }}</router-link>
        </span>
        <span class="text_right">{{ $t("langs.address") }}：{{ $t("langs.region") }}</span>
      </div>
      <div class="footer_text">
        <span class="text_left">
          <router-link to="/centermotorcycle">
            {{
            $t("langs.wificommunication")
            }}
          </router-link>
        </span>
        <span class="text_center">
          <router-link to="/about">{{ $t("langs.contactleague") }}</router-link>
        </span>
        <span class="text_right"></span>
      </div>
      <div class="copyright">
        <block v-if="this.$origin.indexOf('araypower.com') > -1">
            {{ $t("langs.copyright_com") }}
            <a href="https://beian.miit.gov.cn" target="_blank" >粤ICP备10211535号-3</a>
        </block>
        <block v-else>
            {{ $t("langs.copyright_cn") }}
            <a  href="https://beian.miit.gov.cn"  target="_blank" >粤ICP备2023003746号-1</a>
        </block>
      </div>
    </div>
    <div class="right">
      <img :src="this.$path + '/assets/images/wxxiaochengxu.jpg'" :alt="$t('langs.weixinapp')" />
      <img :src="this.$path + '/assets/images/app.png'" :alt="$t('langs.androidapp')" />
      <div
        :class="
          this.$store.state.currentLang === 'zh' ? 'mini-apps-zh' : 'mini-apps'
        "
      >{{ $t("langs.weixinapp") }}</div>
      <div
        :class="
          this.$store.state.currentLang === 'zh'
            ? 'android-apps-zh'
            : 'android-apps'
        "
      >{{ $t("langs.androidapp") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      qqstyle: "display:none",
      telstyle: "display:none",
      wxstyle: "display:none"
    };
  },

  methods: {
    mouseenter(target) {
      switch (target) {
        case "qq": {
          this.qqstyle = "display: list-item;";
          break;
        }
        case "tel": {
          this.telstyle = "display: list-item;";
          break;
        }
        case "wx": {
          this.wxstyle = "display: list-item;";
          break;
        }
      }
    },
    mouseleave() {
      this.qqstyle = "display: none";
      this.telstyle = "display: none";
      this.wxstyle = "display: none";
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/common.css";

.footer {
  width: 100%;
  height: 280px;
  background-color: rgba(216, 216, 216, 0.12);
  margin-top: 30px;
  padding-top: 45px;
  position: initial;
  display: flex;
  flex-direction: row;
  bottom: 0;
  text-align: center;
}

.title_footer {
  border-bottom: 1px solid rgb(216, 216, 216);
  padding-bottom: 5px;
}

.left {
  text-align: right;
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  width: 24%;
}

.small_logo {
  padding-right: 18%;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
}

.small_logo img {
  width: 154px;
  height: 54px;
}

.small_imgs {
  padding-left: 15%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.small_imgs img {
  width: 24px;
  height: 24px;
  margin-top: 25px;
  padding: 0 15px;
}

.center {
  text-align: center;
  width: 40%;
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  flex: 1;
}

.center div {
  margin-bottom: 15px;
  text-align: center;
}

.text_left {
  width: 40%;
  text-align: left;
}

.text_center {
  width: 20%;
  text-align: left;
  padding-right: 3%;
}

.text_right {
  width: 42%;
  text-align: left;
}

.footer_title {
  width: auto;
  display: flex;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
}

.footer_text {
  width: auto;
  display: flex;
}

.right {
  width: 25%;
  text-align: left;
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
}

.right img {
  width: 110px;
  height: 110px;
  padding-top: 10px;
  padding-left: 7%;
}

.copyright {
  font-size: 13px;
  text-align: left;
  margin-top: 20px;
  color: #aaaaaa;
}

.copyright a {
  color: #0068ff;
}

.mini-apps {
  margin-top: 10px;
}

.mini-apps-zh {
  margin-top: 10px;
  margin-left: 12%;
}

.android-apps {
  margin-left: 46%;
  margin-top: -20px;
}

.android-apps-zh {
  margin-left: 50%;
  margin-top: -20px;
}

.info {
  position: relative;
  top: -15px;
  left: 40%;
   background: #018d75;
  transition: all 0.5s;
  list-style: none;
  width: 120px;
  border-radius: 5px;
}
ul {
  padding: 0;
  margin: 0;
}
.info li {
  text-align: center;
  color: #ccc;
  font-size: 14px;
}
.info li p {
  height: 91px;
  width: 80px;
  padding: 10px;
}
.info li p a {
  display: block;
  height: 28px;
  line-height: 28px;
  text-align: center;
  text-decoration: none;
  border: 1px solid #7fb4ab;
  border-radius: 5px;
  margin: 0px 10px;
}
.info .tel_consult {
  display: inline-block;
  padding: 10px;
  line-height: 25px;
  margin-left: -3px;
}
.info li div.img {
  width: 80px;
  height: 100px;
  margin-left: 2.5px;
  margin-top: 14px;
  padding: 1px 10px 10px 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/footer/footer.vue